import { render, staticRenderFns } from "./SubmittedSuccess.vue?vue&type=template&id=dacb1a3e&scoped=true"
import script from "./SubmittedSuccess.vue?vue&type=script&lang=js"
export * from "./SubmittedSuccess.vue?vue&type=script&lang=js"
import style0 from "./SubmittedSuccess.vue?vue&type=style&index=0&id=dacb1a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacb1a3e",
  null
  
)

export default component.exports